import { Box } from "@mui/material";
import HeroSection from "./Home/HeroSection";
import CategoriesSection from "./Home/CategoriesSection/CategoriesSectionComponents";
import PromotionsSection from "./Home/PromotionsSection/PromotionsSectionCompo";
import BestSellersSection from "./Home/BestSellersSection/BestSellersSection";
import NewArrivalsSection from "./Home/NewArrivalsSection/NewArrivalsSection";
import TopRatedSection from "./Home/TopRatedSection/TopRatedSection";
import SavedProducts from "./Home/SavedProducts"; // new component
import AdvertisingBanners from "./Home/AdvertisingBanners";

const Home = () => {
  // show saved products only when a user exists in localStorage
  const hasUser = !!localStorage.getItem("user");
  return (
    <Box sx={{ minHeight: "100vh" }}>
      <HeroSection />
      <CategoriesSection />
      {hasUser && <SavedProducts />}
      <PromotionsSection />
      <BestSellersSection />
      <NewArrivalsSection />
      <AdvertisingBanners />
      <TopRatedSection />
    </Box>
  );
};

export default Home;
